/**
 * Custom metafield bundle PDP (custom.bundle_product_list)
 * Stepped colours + per-item personalisation + gift from main product.
 */
(function ($) {
  'use strict';

  function setupRoot() {
    return $('.jsc-bundle-list-setup').first();
  }

  function syncVisibleStepBorders() {
    var $root = setupRoot();
    if (!$root.length) return;
    var $steps = $root.find('.jsc-bundle-list-step');
    $steps.removeClass('jsc-bundle-list-step--last-visible');
    var $visible = $steps.filter(function () {
      var el = this;
      if (el.hasAttribute('hidden')) return false;
      // Step 2 may be display:none via inline style when no personalisation
      return $(el).css('display') !== 'none';
    });
    $visible.last().addClass('jsc-bundle-list-step--last-visible');
  }

  function moveGiftIntoStep() {
    var $root = setupRoot();
    if (!$root.length) return;
    var $step = $root.find('.jsc-bundle-list-step-gift');
    var $slot = $root.find('.jsc-bundle-list-gift-slot');
    var $gift = $('.gift-container').first();

    if ($slot.length && $gift.length && !$gift.closest('.jsc-bundle-list-gift-slot').length) {
      $slot.append($gift);
    }

    // Hide Ribbon / packaging step when main product has no gift-container setup
    if ($gift.length && $gift.children().length) {
      $step.prop('hidden', false);
    } else {
      $step.prop('hidden', true);
    }
    syncVisibleStepBorders();
  }

  function scheduleGiftMove() {
    moveGiftIntoStep();
    setTimeout(moveGiftIntoStep, 50);
    setTimeout(moveGiftIntoStep, 300);
    setTimeout(moveGiftIntoStep, 800);
  }

  function syncSelectedFontLabels($card) {
    $card.find('.font-type-container .jsc-option[selected="selected"], .layout-container .jsc-option[selected="selected"]').each(function () {
      var $opt = $(this);
      var $wrap = $opt.closest('.jsc-custom-selector');
      $wrap.find('.jsc-selected-text').first().text($.trim($opt.text()));
    });
  }

  function markOptionSelected($opt) {
    if (!$opt || !$opt.length) return;
    var $selector = $opt.closest('.jsc-custom-selector');
    $opt.attr('selected', 'selected');
    $opt.siblings('.jsc-option').removeAttr('selected');
    $selector.find('.jsc-selected-text').first().text($.trim($opt.text()));
    $selector.removeClass('active');
  }

  // Mirror leather PDP character rules (Copperplate 10mm / Script Sentence 6mm / default).
  function sanitizeBundlePersonalisationText(fontName, fontSize, text) {
    var _ltext = String(text == null ? '' : text);
    var name = String(fontName || '');
    var size = String(fontSize || '');
    var temp;
    if (name === 'Copperplate' && size === '10mm') {
      temp = _ltext.replace(/[^-'.&a-zA-Z@#\s]/g, '').replace(/\*/g, '').replace(/\+/g, '').replace(/'/g, '').replace(/[0-9]/g, '');
    } else if (name === 'Script Sentence' && size === '6mm') {
      temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replace(/\*/g, '').replace(/\+/g, '').replace(/'/g, '').replace(/\./g, '');
    } else {
      temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replace(/\*/g, '').replace(/\+/g, '');
    }
    return temp;
  }

  function getCardFontMeta($card) {
    var $font = $card.find('.font-type-container .jsc-option[selected="selected"]').first();
    if (!$font.length) $font = $card.find('.font-type-container .jsc-option').first();
    return {
      $font: $font,
      fontName: String($font.attr('data-font-name') || 'Copperplate'),
      fontFamilyCss: String($font.attr('data-font-name') || 'Copperplate').replace(/\s/g, ''),
      fontSizePx: String($font.attr('data-font-size') || ''),
      fontSizeMm: String($font.attr('data-size') || ''),
      charLimit: parseInt($font.attr('data-character') || 15, 10)
    };
  }

  function getCardOverlays(handle) {
    return $('.product-gallery__media[data-bundle-list-handle="' + handle + '"] .personalisation-text');
  }

  function getCardOverlayParents(handle) {
    return $('.product-gallery__media[data-bundle-list-handle="' + handle + '"] .personalisation-text-overlay');
  }

  function applyFoilToOverlays($overlays, $foilOpt, colourForDeboss) {
    if (!$overlays.length || !$foilOpt || !$foilOpt.length) return;
    var foilVal = String($foilOpt.attr('data-val') || $foilOpt.data('val') || '');
    var foilColor = String($foilOpt.attr('data-foil') || '');
    var texture = String($foilOpt.attr('data-texture') || '');
    var bgTexture = "-webkit-linear-gradient(top, transparent, transparent), url('" + texture + "') center center no-repeat";

    $overlays.css('color', foilColor);
    $overlays.css('text-shadow', ' ');
    $overlays.css('opacity', ' ');
    $overlays.css('background', bgTexture);

    if (foilVal === 'Black') {
      $overlays.css('background', '#000000');
    } else if (foilVal === 'White') {
      $overlays.css('background', '#FFFFFF');
    } else if (foilVal === 'Blind Deboss') {
      var hasdebosscol = false;
      $('.deboss-color-data').each(function () {
        if (String($(this).val()) === String(colourForDeboss || '')) {
          $overlays.css('background', $(this).attr('data-coldeboss'));
          hasdebosscol = true;
        }
      });
      if (!hasdebosscol) $overlays.css('background', '#666666');
      $overlays.css('color', 'transparent');
      $overlays.css('opacity', '1');
    }
  }

  function applyLayoutToOverlays(handle, $posOpt) {
    if (!$posOpt || !$posOpt.length) return;
    var $parents = getCardOverlayParents(handle);
    if (!$parents.length) return;
    var top = $posOpt.attr('data-ltop') || '';
    var left = $posOpt.attr('data-lleft') || '';
    var topTransform = $posOpt.attr('data-topTransform') || '-50%';
    var leftTransform = $posOpt.attr('data-leftTransform') || '-50%';
    $parents.css({
      top: top,
      left: left,
      transform: 'translate(' + leftTransform + ',' + topTransform + ')'
    });
  }

  function applyFontStylesToOverlays($overlays, $input, fontMeta) {
    var fontFamilyCss = fontMeta.fontFamilyCss;
    var fontSizePx = fontMeta.fontSizePx;
    $overlays.css('font-family', fontFamilyCss);
    if ($(window).width() > 481) {
      if (fontSizePx) $overlays.css('font-size', fontSizePx);
    } else if (fontSizePx) {
      var desk = parseInt(String(fontSizePx).replace(/px/gi, ''), 10);
      if (!isNaN(desk)) $overlays.css('font-size', (desk * 0.7) + 'px');
    }

    if (fontFamilyCss === 'GoudySentence' || fontFamilyCss === 'ScriptSentence' || fontFamilyCss === 'Plantin') {
      $overlays.css('text-transform', 'none');
      if ($input && $input.length) $input.css('text-transform', 'none');
    } else {
      $overlays.css('text-transform', 'uppercase');
      if ($input && $input.length) $input.css('text-transform', 'uppercase');
    }
  }

  function ensureCardDefaults($card) {
    var $firstFont = $card.find('.font-type-container .jsc-option[selected="selected"]').first();
    if (!$firstFont.length) {
      $firstFont = $card.find('.font-type-container .jsc-option').first();
      if ($firstFont.length) markOptionSelected($firstFont);
    } else {
      markOptionSelected($firstFont);
    }

    var $firstPos = $card.find('.layout-container .jsc-option[selected="selected"]').first();
    if (!$firstPos.length) {
      $firstPos = $card.find('.layout-container .jsc-option').first();
      if ($firstPos.length) markOptionSelected($firstPos);
    } else {
      markOptionSelected($firstPos);
    }

    if (!$card.find('.foil-option.foil-selected').length) {
      $card.find('.foil-option').first().addClass('foil-selected');
    }
    syncSelectedFontLabels($card);
  }

  function initPersonaliseCards() {
    $(document).on('change', '.jsc-bundle-list-personalise-enable', function () {
      var $cb = $(this);
      var $card = $cb.closest('.jsc-bundle-list-personalise-card');
      var $fields = $card.find('.jsc-bundle-list-personalise-fields');
      var handle = String($card.data('product-handle') || '');
      if ($cb.is(':checked')) {
        $fields.prop('hidden', false);
        ensureCardDefaults($card);
        syncPersonalisationOverlayForCard($card, { slideToPreview: true });
      } else {
        $fields.prop('hidden', true);
        $card.find('.jsc-bundle-list-text').val('');
        $card.find('.jsc-bundle-list-input-error').hide();
        syncPersonalisationOverlayForCard($card, { slideToPreview: false });
        jscBundleListFilterGallery(handle, false);
      }
    });

    $(document).on('input change compositionend', '.jsc-bundle-list-text', function () {
      var $input = $(this);
      var $card = $input.closest('.jsc-bundle-list-personalise-card');
      var fontMeta = getCardFontMeta($card);
      var max = fontMeta.charLimit || parseInt($input.attr('maxlength') || $input.data('maxlength') || 15, 10);
      var val = sanitizeBundlePersonalisationText(fontMeta.fontName, fontMeta.fontSizeMm, $input.val());
      if (typeof jscClampLeatherTextToMaxlength === 'function') {
        val = jscClampLeatherTextToMaxlength(val, $input[0]);
      } else if (val.length > max) {
        val = val.slice(0, max);
      }
      $input.attr('maxlength', max).data('maxlength', max).val(val);
      $card.find('.jsc-bundle-list-char').text(val.length + '/' + max);
      if (val) $card.find('.jsc-bundle-list-input-error').hide();
      syncPersonalisationOverlayForCard($card, { slideToPreview: false });
    });

    $(document).on('paste', '.jsc-bundle-list-text', function () {
      var $input = $(this);
      var $card = $input.closest('.jsc-bundle-list-personalise-card');
      setTimeout(function () {
        $input.trigger('input');
        syncPersonalisationOverlayForCard($card, { slideToPreview: false });
      }, 0);
    });

    $(document).on('click', '.jsc-bundle-list-remove-personalise', function (e) {
      e.preventDefault();
      var idx = $(this).data('bundle-list-index');
      var $card = $('.jsc-bundle-list-personalise-card[data-bundle-list-index="' + idx + '"]');
      $card.find('.jsc-bundle-list-personalise-enable').prop('checked', false).trigger('change');
    });
  }

  window.jscBundleListFoil = function (el) {
    var $el = $(el);
    var $card = $el.closest('.jsc-bundle-list-personalise-card');
    $card.find('.foil-option').removeClass('foil-selected');
    $el.addClass('foil-selected');
    $card.find('.jsc-bundle-list-foil-label').text($el.attr('data-val') || $el.data('val') || '');
    syncPersonalisationOverlayForCard($card, { slideToPreview: false });
  };

  window.jscBundleListSelectFont = function (el) {
    var $el = $(el);
    var $card = $el.closest('.jsc-bundle-list-personalise-card');
    markOptionSelected($el);

    var max = parseInt($el.attr('data-character') || 15, 10);
    var $input = $card.find('.jsc-bundle-list-text');
    $input.attr('maxlength', max).data('maxlength', max);

    // Copperplate 10mm strips digits immediately (same as leather removeDigitsPersonalisation)
    var fontName = String($el.attr('data-font-name') || '');
    var fontSizeMm = String($el.attr('data-size') || '');
    var val = sanitizeBundlePersonalisationText(fontName, fontSizeMm, $input.val());
    if (typeof jscClampLeatherTextToMaxlength === 'function') {
      val = jscClampLeatherTextToMaxlength(val, $input[0]);
    } else if (val.length > max) {
      val = val.slice(0, max);
    }
    $input.val(val);
    $card.find('.jsc-bundle-list-char').text(val.length + '/' + max);
    syncPersonalisationOverlayForCard($card, { slideToPreview: false });
  };

  window.jscBundleListSelectPosition = function (el) {
    var $el = $(el);
    var $card = $el.closest('.jsc-bundle-list-personalise-card');
    markOptionSelected($el);
    syncPersonalisationOverlayForCard($card, { slideToPreview: false });
  };

  // Back-compat alias
  window.jscBundleListFontChange = window.jscBundleListSelectFont;

  function updateRowThumb($row, imageUrl) {
    if (!imageUrl) return;
    var $img = $row.find('.jsc-bundle-list-colour-thumb');
    if ($img.length) $img.attr('src', imageUrl);
  }

  function getBundleListColourSelections() {
    var selections = [];
    $('.jsc-bundle-list-colour-row').each(function () {
      var $row = $(this);
      selections.push({
        handle: String($row.data('product-handle') || ''),
        color: String($row.find('.jsc-bundle-list-colour-select').attr('data-option1') || ''),
        personalised: $row.data('bundle-list-index') !== undefined
          ? $('.jsc-bundle-list-personalise-card[data-bundle-list-index="' + $row.data('bundle-list-index') + '"] .jsc-bundle-list-personalise-enable').is(':checked')
          : false
      });
    });
    return selections;
  }

  function mediaMatchesBundleSelection(altText, color, preferText) {
    if (!altText) return false;
    if (typeof jscIsMainImageAlt === 'function' && jscIsMainImageAlt(altText)) {
      return false;
    }
    if (!color) return false;
    if (preferText) {
      return altText === color + '-text' || altText.indexOf(color + '-text') !== -1;
    }
    if (typeof jscMediaMatchesColor === 'function') {
      return jscMediaMatchesColor(altText, color, 'xx', 'xx') && !jscIsMainImageAlt(altText);
    }
    return altText === color
      || altText === color + '-text'
      || altText.indexOf(color + '-text') !== -1;
  }

  // Filter gallery per list-product handle + selected colour so both products keep their own Grey-text / Black-text sets.
  function jscBundleListFilterGallery(preferredHandle, preferTextForHandle) {
    var $media = $('.product-gallery__media[data-bundle-list-handle]');
    var $thumbs = $('.jsc-thumbnail[data-bundle-list-handle]');
    if (!$media.length) return;

    var selections = getBundleListColourSelections();
    var selectionByHandle = {};
    for (var i = 0; i < selections.length; i++) {
      selectionByHandle[selections[i].handle] = selections[i];
    }

    function shouldShow(el) {
      var $el = $(el);
      var handle = String($el.attr('data-bundle-list-handle') || '');
      var alt = String($el.attr('data-img-alt') || '');
      var sel = selectionByHandle[handle];
      if (!sel || !sel.color) return false;
      // Keep both colour and colour-text for that product so overlays exist in the strip
      return mediaMatchesBundleSelection(alt, sel.color, false);
    }

    $media.each(function () {
      if (shouldShow(this)) $(this).show();
      else $(this).hide();
    });
    $thumbs.each(function () {
      if (shouldShow(this)) $(this).show();
      else $(this).hide();
    });

    var focusHandle = preferredHandle || (selections[0] && selections[0].handle);
    var focusSel = focusHandle && selectionByHandle[focusHandle] ? selectionByHandle[focusHandle] : null;
    var focusColor = focusSel ? focusSel.color : '';
    if (!focusHandle || !focusColor) return;

    var wantText = preferTextForHandle === true || preferTextForHandle === 'text';
    var wantColourSlide = preferTextForHandle === 'color';
    var $target = $();
    var textNeedle = focusColor + '-text';

    if (wantText) {
      $thumbs.each(function () {
        var $t = $(this);
        if (!$t.is(':visible')) return;
        if (String($t.attr('data-bundle-list-handle')) !== focusHandle) return;
        var alt = String($t.attr('data-img-alt') || '');
        if (alt === textNeedle || alt.indexOf(textNeedle) !== -1) {
          $target = $t;
          return false;
        }
      });
    }
    if (!$target.length && (wantText || wantColourSlide)) {
      $thumbs.each(function () {
        var $t = $(this);
        if ($t.is(':visible') && String($t.attr('data-bundle-list-handle')) === focusHandle) {
          var alt = String($t.attr('data-img-alt') || '');
          // Prefer plain colour (not -text) when sliding for a colour change
          if (wantColourSlide && (alt === textNeedle || alt.indexOf(textNeedle) !== -1)) return;
          $target = $t;
          return false;
        }
      });
    }
    if (!$target.length && (wantText || wantColourSlide)) {
      $thumbs.each(function () {
        var $t = $(this);
        if ($t.is(':visible') && String($t.attr('data-bundle-list-handle')) === focusHandle) {
          $target = $t;
          return false;
        }
      });
    }

    // Switch gallery to -text / colour slide without scrolling the page
    if ($target.length && (wantText || wantColourSlide)) {
      setTimeout(function () {
        $target.trigger('click');
      }, 30);
    }
  }

  function syncPersonalisationOverlayForCard($card, opts) {
    opts = opts || {};
    if (!$card || !$card.length) return;
    var handle = String($card.data('product-handle') || '');
    if (!handle) return;

    var enabled = $card.find('.jsc-bundle-list-personalise-enable').is(':checked');
    var $input = $card.find('.jsc-bundle-list-text');
    var fontMeta = getCardFontMeta($card);
    var $pos = $card.find('.layout-container .jsc-option[selected="selected"]').first();
    var $foil = $card.find('.foil-option.foil-selected').first();
    var $overlays = getCardOverlays(handle);
    var colour = String(
      $('.jsc-bundle-list-colour-row[data-product-handle="' + handle + '"] .jsc-bundle-list-colour-select').attr('data-option1') || ''
    );

    var text = '';
    if (enabled) {
      text = sanitizeBundlePersonalisationText(fontMeta.fontName, fontMeta.fontSizeMm, $input.val());
      if (typeof jscClampLeatherTextToMaxlength === 'function') {
        text = jscClampLeatherTextToMaxlength(text, $input[0]);
      } else if (text.length > fontMeta.charLimit) {
        text = text.slice(0, fontMeta.charLimit);
      }
      if (String($input.val() || '') !== text) $input.val(text);
      $input.attr('maxlength', fontMeta.charLimit).data('maxlength', fontMeta.charLimit);
      $card.find('.jsc-bundle-list-char').text(text.length + '/' + fontMeta.charLimit);
    }

    // Always write text + styles onto this product's overlays (even empty when disabled)
    $overlays.text(text);
    applyFontStylesToOverlays($overlays, $input, fontMeta);
    applyFoilToOverlays($overlays, $foil, colour);
    applyLayoutToOverlays(handle, $pos);
    $overlays.show();

    // Only jump to the -text preview when the personalisation checkbox is checked
    if (enabled && opts.slideToPreview === true) {
      jscBundleListFilterGallery(handle, true);
    }
  }

  function getBundleListAtc() {
    return $('.jsc-bundle-list-atc, button[data-bundle-list-atc="true"]');
  }

  function syncColourAtcState() {
    if (!setupRoot().length) return;
    var anySoldOut = false;
    $('.jsc-bundle-list-colour-select').each(function () {
      if (String($(this).attr('data-available')) === 'false') anySoldOut = true;
    });
    var $atc = getBundleListAtc();
    if (!$atc.length) return;

    var addLabel = $atc.attr('data-atc-label')
      || (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.addToCartButton)
      || 'Add to cart';
    var soldLabel = (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.soldOutButton)
      || 'Sold out';

    var editLabel = ($('body').hasClass('jsc-bundle-list-edit-mode') || hasBundleListEditUrlFlag())
      ? 'Update'
      : addLabel;

    if (anySoldOut) {
      $atc.prop('disabled', true).attr('disabled', 'disabled').addClass('is-sold-out').text(soldLabel);
    } else {
      $atc.prop('disabled', false).removeAttr('disabled').removeClass('is-sold-out').text(editLabel);
    }
  }

  function closeAllColourDropdowns(exceptWrap) {
    $('.jsc-bundle-list-colour-select-wrap').each(function () {
      if (exceptWrap && this === exceptWrap) return;
      var $wrap = $(this);
      $wrap.find('.jsc-bundle-list-colour-menu').prop('hidden', true);
      $wrap.find('.jsc-bundle-list-colour-trigger').attr('aria-expanded', 'false');
    });
  }

  window.jscBundleListToggleColourDropdown = function (el) {
    var $btn = $(el);
    var $wrap = $btn.closest('.jsc-bundle-list-colour-select-wrap');
    var $menu = $wrap.find('.jsc-bundle-list-colour-menu');
    var isOpen = $btn.attr('aria-expanded') === 'true';

    closeAllColourDropdowns(isOpen ? null : $wrap[0]);

    if (isOpen) {
      $menu.prop('hidden', true);
      $btn.attr('aria-expanded', 'false');
    } else {
      $menu.prop('hidden', false);
      $btn.attr('aria-expanded', 'true');
    }
  };

  window.jscBundleListColourSelect = function (el) {
    var $opt = $(el);
    var $wrap = $opt.closest('.jsc-bundle-list-colour-select-wrap');
    var $row = $opt.closest('.jsc-bundle-list-colour-row');
    var $hidden = $row.find('.jsc-bundle-list-colour-select');
    var imageUrl = $opt.attr('data-image');
    var optionLabel = $opt.attr('data-option1') || $.trim($opt.find('.jsc-bundle-list-colour-option-label').text()) || $.trim($opt.text());

    $wrap.find('.jsc-bundle-list-colour-option').removeAttr('selected').attr('aria-selected', 'false');
    $opt.attr('selected', 'selected').attr('aria-selected', 'true');
    $wrap.find('.jsc-selected-text').text($.trim($opt.find('.jsc-bundle-list-colour-option-label').text()) || optionLabel);
    closeAllColourDropdowns();

    $hidden
      .val($opt.attr('data-variant-id'))
      .attr('data-option1', optionLabel)
      .attr('data-available', $opt.attr('data-available'))
      .attr('data-image', imageUrl || '');

    updateRowThumb($row, imageUrl);
    syncColourAtcState();
    var handle = String($row.data('product-handle') || '');
    var idx = $row.data('bundle-list-index');
    var $card = $('.jsc-bundle-list-personalise-card[data-bundle-list-index="' + idx + '"]');
    jscBundleListFilterGallery(handle, 'color');
    if ($card.length) syncPersonalisationOverlayForCard($card, { slideToPreview: false });
  };

  function initColourSelects() {
    syncColourAtcState();

    $(document).off('click.jscBundleListColour').on('click.jscBundleListColour', function (e) {
      if ($(e.target).closest('.jsc-bundle-list-colour-select-wrap').length) return;
      closeAllColourDropdowns();
    });

    $(document).off('keydown.jscBundleListColour').on('keydown.jscBundleListColour', function (e) {
      if (e.key === 'Escape') closeAllColourDropdowns();
    });

    jscBundleListFilterGallery(
      String($('.jsc-bundle-list-colour-row').first().data('product-handle') || ''),
      false
    );
  }

  function collectPersonalisation($card) {
    if (!$card.length || !$card.find('.jsc-bundle-list-personalise-enable').is(':checked')) {
      return null;
    }
    var $text = $card.find('.jsc-bundle-list-text');
    var fontMeta = getCardFontMeta($card);
    var inputText = sanitizeBundlePersonalisationText(fontMeta.fontName, fontMeta.fontSizeMm, $.trim($text.val() || ''));
    if (typeof jscClampLeatherTextToMaxlength === 'function') {
      inputText = jscClampLeatherTextToMaxlength(inputText, $text[0]);
    }
    var $layout = $card.find('.layout-container .jsc-option[selected="selected"]');
    var $foil = $card.find('.foil-option.foil-selected');
    var fontType = $.trim(fontMeta.fontName || '');
    var fontSize = $.trim(fontMeta.fontSizeMm || '');
    var layout = $.trim($layout.text() || '');
    var foil = $foil.attr('data-val') || $foil.data('val') || '';

    if (!inputText) {
      $card.find('.jsc-bundle-list-input-error').show();
      return { error: true };
    }
    if (!fontType || !fontSize) {
      return { error: true };
    }

    if (fontType === 'Copperplate' || fontType === 'Script' || fontType === 'Univers') {
      inputText = inputText.toUpperCase();
    }

    return {
      Personalisation: inputText,
      'Font Type': fontType,
      'Font Size': fontSize,
      'Font Position': layout,
      'Foil Colour': foil
    };
  }

  function buildWithLabels(rows) {
    return rows.map(function (r) {
      return r.title + ' / ' + r.option;
    }).join(', ');
  }

  window.bundleListAddToCart = function () {
    var $root = setupRoot();
    if (!$root.length) {
      console.warn('bundleListAddToCart: setup missing');
      return;
    }

    var editCtx = getActiveBundleListEditContext();
    var bundleHandle = $root.data('bundle-handle') || (editCtx && editCtx.bundleHandle) || '';
    var bundleTitle = $root.data('bundle-title') || '';
    var rows = [];
    var valid = true;

    $root.find('.jsc-bundle-list-colour-row').each(function () {
      var $row = $(this);
      var idx = $row.data('bundle-list-index');
      var $hidden = $row.find('.jsc-bundle-list-colour-select');
      var vid = parseInt($hidden.val(), 10);
      if (!vid || String($hidden.attr('data-available')) === 'false') {
        valid = false;
        return false;
      }
      var $card = $root.find('.jsc-bundle-list-personalise-card[data-bundle-list-index="' + idx + '"]');
      var personalisation = collectPersonalisation($card);
      if (personalisation && personalisation.error) {
        valid = false;
        return false;
      }
      rows.push({
        index: idx,
        id: vid,
        title: $row.data('product-title') || '',
        handle: String($row.data('product-handle') || ''),
        option: $hidden.attr('data-option1') || '',
        personalisation: personalisation
      });
    });

    if (!valid || !rows.length) {
      return;
    }

    function pushBundleListItems(bindId, qty) {
      qty = parseInt(qty, 10) || 1;
      var giftWrap = $('.gift-container .gift-radio:checked, .gift-container input:checked').first();
      var packaging = giftWrap.val() || '';
      var giftVid = parseInt(giftWrap.attr('data-vid'), 10);
      var giftPrice = parseInt(giftWrap.next().attr('data-price-number') || giftWrap.attr('data-price-number') || 0, 10);

      var blankCard = 'No';
      if ($('#pdpGiftCheckbox3').is(':checked')) blankCard = $('#pdpGiftCheckbox3').val() || 'Yes';
      var giftMessage = $('.jsc-pdp-gift-message-wrapper .jsc-pdp-gift-message-input').val() || '';

      var allLabels = buildWithLabels(rows);
      var jsonObj = [];

      rows.forEach(function (row, i) {
        var props = {
          BindID: bindId,
          BundleHandle: bundleHandle,
          BundleProduct: i === 0 ? 'main' : 'child',
          BundleWith: allLabels,
          Packaging: packaging
        };
        if (bundleTitle) props['Bundle Title'] = bundleTitle;

        if (i === 0) {
          if ($('#pdpGiftCheckbox3').prop('checked')) props['Blank Card'] = blankCard;
          else if ($('#pdpGiftCheckbox4').prop('checked')) props['Gift Message'] = giftMessage;
          if ($('#pdpGiftCheckboxMdayPostcard').length) {
            props["Mother's Day Postcard"] = $('#pdpGiftCheckboxMdayPostcard').is(':checked') ? 'Yes' : 'No';
          }
        }

        if (row.personalisation) {
          props.Personalisation = row.personalisation.Personalisation;
          props['Font Type'] = row.personalisation['Font Type'];
          props['Font Size'] = row.personalisation['Font Size'];
          props['Font Position'] = row.personalisation['Font Position'];
          props['Foil Colour'] = row.personalisation['Foil Colour'];
        }

        jsonObj.push({ id: row.id, quantity: qty, properties: props });
      });

      if (giftVid && giftPrice > 0) {
        jsonObj.push({
          id: giftVid,
          quantity: qty,
          properties: {
            BindID: bindId,
            BundleHandle: bundleHandle,
            'Gift Wrap': packaging,
            BundleProduct: 'child'
          }
        });
      }

      CartJS.addItems(jsonObj, {
        success: function () {
          if (editCtx) clearBundleListEditContext();
          console.log('bundleListAddToCart success');
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log('bundleListAddToCart error', errorThrown, textStatus);
        }
      });
    }

    // Edit mode: remove entire BindID set, then re-add the updated bundle
    if (editCtx && editCtx.bindId) {
      var editQty = parseInt(editCtx.quantity, 10) || 1;
      removeBundleListEditCartLines(editCtx, function () {
        var now = new Date();
        var uniqueDate = now.toISOString().replace(/[-:.]/g, '').slice(0, 14);
        var bindRaw = rows.map(function (r) { return r.id; }).join('-') + '-' + uniqueDate + '-' + bundleHandle;
        var newBindId = bindRaw.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        pushBundleListItems(newBindId, editQty);
      });
      return;
    }

    var now = new Date();
    var uniqueDate = now.toISOString().replace(/[-:.]/g, '').slice(0, 14);
    var bindRaw = rows.map(function (r) { return r.id; }).join('-') + '-' + uniqueDate + '-' + bundleHandle;
    var bindId = bindRaw.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    pushBundleListItems(bindId, 1);
  };

  window.jscBundleListCartQty = function (el, delta) {
    var $wrap = $(el).closest('.jsc-bundle-list-cart-qty');
    if (!$wrap.length || typeof CartJS === 'undefined') return;
    var keys = String($wrap.attr('data-bind-keys') || '').split(',').filter(Boolean);
    var qty = parseInt($wrap.attr('data-qty') || $wrap.find('input').val() || 1, 10);
    if (isNaN(qty)) qty = 1;
    var next = qty + delta;
    if (next < 1) next = 0;
    if (!keys.length) return;

    var jsonObj = {};
    for (var i = 0; i < keys.length; i++) {
      jsonObj[keys[i]] = next;
    }
    CartJS.updateItemQuantitiesById(jsonObj);
  };

  // --- Edit personalisation from cart (like feature/edit-nb) ---
  var BUNDLE_LIST_EDIT_KEY = 'bynd_bundle_list_edit_personalisation';

  function hasBundleListEditUrlFlag() {
    try {
      return new URLSearchParams(window.location.search).get('edit_personalisation') === '1'
        && new URLSearchParams(window.location.search).get('edit_type') === 'bundle-list';
    } catch (e) {
      return /[?&]edit_personalisation=1(?:&|$)/.test(String(window.location.search))
        && /[?&]edit_type=bundle-list(?:&|$)/.test(String(window.location.search));
    }
  }

  function readBundleListEditSession() {
    try {
      var raw = sessionStorage.getItem(BUNDLE_LIST_EDIT_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearBundleListEditContext() {
    try {
      sessionStorage.removeItem(BUNDLE_LIST_EDIT_KEY);
    } catch (e) {}
    $('body').removeClass('jsc-bundle-list-edit-mode');
    hideBundleListEditLoadingOverlay();
    getBundleListAtc().each(function () {
      var $btn = $(this);
      var label = $btn.attr('data-atc-label')
        || (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.addToCartButton)
        || 'Add to cart';
      $btn.text(label);
    });
    try {
      if (hasBundleListEditUrlFlag() && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.delete('edit_personalisation');
        url.searchParams.delete('edit_line');
        url.searchParams.delete('edit_bind');
        url.searchParams.delete('edit_type');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    } catch (e) {}
  }

  function showBundleListEditLoadingOverlay() {
    var $overlay = $('#jsc-bundle-list-edit-loading-overlay');
    if ($overlay.length) {
      $overlay.addClass('is-visible').attr('aria-busy', 'true');
      return;
    }
    $('body').append(
      '<div id="jsc-bundle-list-edit-loading-overlay" class="jsc-bundle-list-edit-loading-overlay is-visible" aria-live="polite" aria-busy="true">'
      + '<div class="jsc-bundle-list-edit-loading-card">'
      + '<div class="jsc-bundle-list-edit-loading-spinner" aria-hidden="true"></div>'
      + '<p class="jsc-bundle-list-edit-loading-text">Loading your personalisation…</p>'
      + '</div></div>'
    );
  }

  function hideBundleListEditLoadingOverlay() {
    var $overlay = $('#jsc-bundle-list-edit-loading-overlay');
    if (!$overlay.length) return;
    $overlay.removeClass('is-visible').attr('aria-busy', 'false');
    setTimeout(function () {
      $overlay.remove();
    }, 250);
  }

  function getActiveBundleListEditContext() {
    if (!hasBundleListEditUrlFlag() && !$('body').hasClass('jsc-bundle-list-edit-mode')) {
      return null;
    }
    var ctx = readBundleListEditSession();
    if (!ctx || !ctx.bindId) return null;
    if (!setupRoot().length) return null;
    var pathMatch = String(window.location.pathname).match(/\/products\/([^/?#]+)/);
    var currentHandle = pathMatch && pathMatch[1] ? decodeURIComponent(pathMatch[1]) : '';
    if (ctx.bundleHandle && currentHandle && ctx.bundleHandle !== currentHandle) return null;
    return ctx;
  }

  function markBundleListEditModeUi(ctx) {
    if (!ctx) return;
    $('body').addClass('jsc-bundle-list-edit-mode');
    getBundleListAtc().text('Update');
  }

  function selectBundleListDropdownOption($options, matcher) {
    var matched = null;
    $options.each(function () {
      if (matcher($(this))) {
        matched = $(this);
        return false;
      }
    });
    if (matched && matched.length) {
      var onclick = matched.attr('onclick') || '';
      if (onclick.indexOf('jscBundleListSelectFont') !== -1) {
        window.jscBundleListSelectFont(matched[0]);
      } else if (onclick.indexOf('jscBundleListSelectPosition') !== -1) {
        window.jscBundleListSelectPosition(matched[0]);
      } else {
        matched.trigger('click');
      }
      return true;
    }
    return false;
  }

  function prefillsOneBundleListComponent(comp) {
    if (!comp || !comp.productHandle) return;
    var $root = setupRoot();
    if (!$root.length) return;
    var props = comp.properties || {};
    var $row = $root.find('.jsc-bundle-list-colour-row[data-product-handle="' + comp.productHandle + '"]');
    if (!$row.length) return;
    var idx = $row.data('bundle-list-index');
    var $card = $root.find('.jsc-bundle-list-personalise-card[data-bundle-list-index="' + idx + '"]');
    var $opt = $row.find('.jsc-bundle-list-colour-option[data-variant-id="' + comp.variantId + '"]');
    if ($opt.length) {
      window.jscBundleListColourSelect($opt[0]);
    }
    if (!$card.length) return;

    var hasPers = !!(props.Personalisation || props['Font Type'] || props['Foil Colour']);
    var $enable = $card.find('.jsc-bundle-list-personalise-enable');
    if (hasPers) {
      $enable.prop('checked', true).trigger('change');
    }

    setTimeout(function () {
      if (props.Personalisation) {
        $card.find('.jsc-bundle-list-text').val(props.Personalisation).trigger('input');
      }

      if (props['Font Type'] || props['Font Size']) {
        var wantFont = props['Font Type'] ? String(props['Font Type']).trim() : '';
        var wantSize = props['Font Size'] ? String(props['Font Size']).trim() : '';
        selectBundleListDropdownOption(
          $card.find('.font-type-container .jsc-option'),
          function ($opt) {
            var fontName = String($opt.attr('data-font-name') || '').trim();
            var size = String($opt.attr('data-size') || '').trim();
            return (!wantFont || fontName === wantFont)
              && (!wantSize || size === wantSize || size.replace(/\s/g, '') === wantSize.replace(/\s/g, ''));
          }
        );
      }

      if (props['Font Position']) {
        var pos = String(props['Font Position']).replace(/\s+/g, ' ').trim();
        var posNorm = pos.replace(/\s/g, '').toLowerCase().replace(/centre/g, 'center');
        selectBundleListDropdownOption(
          $card.find('.layout-container .jsc-option'),
          function ($opt) {
            var dataVal = String($opt.attr('data-val') || '').trim();
            var label = String($opt.text() || '').replace(/\s+/g, ' ').trim();
            var dataNorm = dataVal.replace(/\s/g, '').toLowerCase().replace(/centre/g, 'center');
            var labelNorm = label.replace(/\s/g, '').toLowerCase().replace(/centre/g, 'center');
            return dataVal === pos || label === pos || dataNorm === posNorm || labelNorm === posNorm;
          }
        );
      }

      if (props['Foil Colour']) {
        var foil = String(props['Foil Colour']).trim();
        var $foil = $card.find('.foil-option').filter(function () {
          return String($(this).attr('data-val') || '') === foil;
        }).first();
        if ($foil.length) window.jscBundleListFoil($foil[0]);
      }

      syncPersonalisationOverlayForCard($card, { slideToPreview: false });
    }, 80);
  }

  function applyBundleListEditPrefill(ctx) {
    if (!ctx || !ctx.bindId) return;
    var $root = setupRoot();
    if (!$root.length) return;

    markBundleListEditModeUi(ctx);

    var components = ctx.components || [];
    for (var i = 0; i < components.length; i++) {
      prefillsOneBundleListComponent(components[i]);
    }

    // Prefill packaging / gift options from stored set props
    var packVal = ctx.packaging || '';
    if (packVal) {
      var $gift = $('.gift-radio, .gift-container input[type="radio"]').filter(function () {
        return String($(this).val() || '') === String(packVal);
      }).first();
      if ($gift.length) {
        var gid = $gift.attr('id');
        if (gid) $('label[for="' + gid + '"]').trigger('click');
        else $gift.prop('checked', true).trigger('click');
      }
    }

    var giftProps = ctx.giftProperties || {};
    if (giftProps['Gift Message']) {
      var $msgCb = $('#pdpGiftCheckbox4');
      if ($msgCb.length && !$msgCb.prop('checked')) {
        $msgCb.prop('checked', true);
        if (typeof window.onPdpGiftCheckboxChange === 'function') {
          window.onPdpGiftCheckboxChange($msgCb[0]);
        }
      }
      $('.jsc-pdp-gift-message-wrapper .jsc-pdp-gift-message-input').val(giftProps['Gift Message']);
    } else if (giftProps['Blank Card']) {
      var $blankCb = $('#pdpGiftCheckbox3');
      if ($blankCb.length && !$blankCb.prop('checked')) {
        $blankCb.prop('checked', true);
        if (typeof window.onPdpGiftCheckboxChange === 'function') {
          window.onPdpGiftCheckboxChange($blankCb[0]);
        }
      }
    }
    if (giftProps["Mother's Day Postcard"] === 'Yes') {
      var $mday = $('#pdpGiftCheckboxMdayPostcard');
      if ($mday.length) $mday.prop('checked', true);
    }

    markBundleListEditModeUi(ctx);

    try {
      var $firstCard = $root.find('.jsc-bundle-list-personalise-card').first();
      var top = (($firstCard.length ? $firstCard.offset() : $root.offset()) || { top: 0 }).top - 80;
      $('html, body').animate({ scrollTop: top }, 300);
    } catch (e) {}
  }

  function removeBundleListEditCartLines(ctx, done) {
    var finish = typeof done === 'function' ? done : function () {};
    var bindId = ctx && ctx.bindId;
    if (!bindId || typeof CartJS === 'undefined') {
      finish();
      return;
    }
    fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var qtyMap = {};
        (data.items || []).forEach(function (item) {
          if (item.properties && item.properties.BindID === bindId) {
            qtyMap[item.key] = 0;
          }
        });
        if (!Object.keys(qtyMap).length) {
          finish();
          return;
        }
        CartJS.updateItemQuantitiesById(qtyMap, {
          success: function () { finish(); },
          error: function () { finish(); }
        });
      })
      .catch(function () { finish(); });
  }

  window.editBundleListPersonalisation = function (el) {
    var $el = $(el);
    var bindId = $el.attr('data-bind-id') || '';
    var bundleHandle = $el.attr('data-bundle-handle') || '';
    var quantity = parseInt($el.attr('data-quantity'), 10) || 1;
    var productUrl = $el.attr('data-product-url') || '';

    if (!bindId || !bundleHandle) return;

    fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var components = [];
        var packaging = '';
        var giftProperties = {};
        var setQty = quantity;

        (data.items || []).forEach(function (item) {
          if (!item.properties || item.properties.BindID !== bindId) return;
          if (item.properties['Gift Wrap']) {
            packaging = item.properties['Gift Wrap'] || packaging;
            return;
          }
          if (item.properties.Packaging) packaging = item.properties.Packaging;
          if (item.properties['Bundle Product'] === 'main' || item.properties.BundleProduct === 'main') {
            setQty = item.quantity || setQty;
            giftProperties = {
              'Blank Card': item.properties['Blank Card'],
              'Gift Message': item.properties['Gift Message'],
              "Mother's Day Postcard": item.properties["Mother's Day Postcard"]
            };
          }
          components.push({
            lineKey: item.key,
            variantId: item.variant_id,
            quantity: item.quantity,
            productHandle: item.handle || '',
            productId: item.product_id,
            properties: item.properties || {}
          });
        });

        if (!components.length) return;

        // Prefer PDP list order: reverse Shopify newest-first for prefill stability
        components = components.slice().reverse();

        var payload = {
          bindId: bindId,
          quantity: setQty,
          bundleHandle: bundleHandle,
          editType: 'bundle-list',
          packaging: packaging,
          giftProperties: giftProperties,
          components: components
        };

        try {
          sessionStorage.setItem(BUNDLE_LIST_EDIT_KEY, JSON.stringify(payload));
        } catch (e) {
          console.error('Could not store bundle list edit context', e);
        }

        var targetBase = productUrl || (window.Shopify.routes.root + 'products/' + payload.bundleHandle);
        var sep = targetBase.indexOf('?') >= 0 ? '&' : '?';
        var target = targetBase
          + sep
          + 'edit_personalisation=1'
          + '&edit_type=bundle-list'
          + '&edit_bind=' + encodeURIComponent(payload.bindId);
        window.location.href = target;
      })
      .catch(function (error) {
        console.error('editBundleListPersonalisation error', error);
      });
  };

  function initBundleListEditOnLoad() {
    if (!hasBundleListEditUrlFlag()) return;
    if (!setupRoot().length) return;

    showBundleListEditLoadingOverlay();

    var attempts = 0;
    var run = function () {
      attempts += 1;
      var ctx = getActiveBundleListEditContext();
      if (!ctx) {
        if (attempts < 15) {
          setTimeout(run, 200);
          return;
        }
        hideBundleListEditLoadingOverlay();
        return;
      }
      applyBundleListEditPrefill(ctx);
      setTimeout(function () {
        applyBundleListEditPrefill(ctx);
        setTimeout(hideBundleListEditLoadingOverlay, 450);
      }, 400);
    };
    setTimeout(run, 100);
  }

  $(function () {
    if (!setupRoot().length) return;
    scheduleGiftMove();
    initPersonaliseCards();
    initColourSelects();
    syncColourAtcState();
    $('.jsc-bundle-list-personalise-card').each(function () {
      syncSelectedFontLabels($(this));
    });
    initBundleListEditOnLoad();
  });
})(jQuery);
